export default "__VITE_ASSET__CakdsMC0__"